import FunnelPage from "./FunnelPage";

export default function FunnelComfortCare() {
  return (
    <FunnelPage
      funnelKey="comfort_care_inquiry"
      eyebrow="KISSED Comfort Care"
      headline="Care for the carer."
      body="KISSED Comfort Care is being designed for those holding space for others — caregivers, professionals, and parents. Tell us your situation and we'll match you with the right support as it becomes available."
      comingNext="Inquiries are read personally by the KISSED comfort team"
      noteLabel="Tell us about your situation (optional)"
      notePlaceholder="Who are you caring for, and what kind of support would help most?"
      testidPrefix="funnel-comfort-care"
    />
  );
}
